import React, { useId } from 'react';
import clsx from 'clsx';
import Check from '@mollie/ui-assets/icons/utilitarian/Check';
import { aggregate, callMultiple, flattenChildren, suffixId, useControlledValue, } from '../../utils';
import { Icon } from '../Icon';
import { useCheckboxListContext } from '../CheckboxList/CheckboxListContext';
import { validationTextId } from '../FormField';
import { VisuallyHidden } from '../VisuallyHidden';
import AlertOutline from '@mollie/ui-assets/icons/utilitarian/AlertOutline';
import { Box } from '../Box';
import './Checkbox.css';
export function Checkbox(props) {
    const { children, id: userId, className, role, prefix, label, complement, description, value, name: userName, checked: userChecked, defaultChecked, disabled, required, onChange, onFocus, onBlur, validationText, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, UNSAFE_omitInput, UNSAFE_elementType = UNSAFE_omitInput ? 'div' : 'label', inputRef, UNSAFE_inputTabIndex, UNSAFE_labelRef, UNSAFE_labelOnBlur, UNSAFE_labelOnFocus, UNSAFE_contentClassName, UNSAFE_indicatorClassName, UNSAFE_indicatorContent, autoFocus, 'data-table-row-tabbable': tableRowTabbable, ...rest } = props;
    const { name: contextName, checkedValues, setCheckedValue, } = useCheckboxListContext();
    const name = userName !== null && userName !== void 0 ? userName : `${contextName}[]`;
    const [checked, setChecked] = useControlledValue({
        value: Array.isArray(checkedValues)
            ? checkedValues.indexOf(value) > -1
            : userChecked,
        defaultValue: defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : false,
    });
    const uniqueId = useId();
    const id = userId !== null && userId !== void 0 ? userId : uniqueId;
    let labelProps;
    if (UNSAFE_elementType === 'label') {
        labelProps = {
            htmlFor: id,
        };
    }
    if (UNSAFE_omitInput) {
        labelProps = {
            ...labelProps,
            role: role !== null && role !== void 0 ? role : 'checkbox',
            'aria-checked': checked !== null && checked !== void 0 ? checked : defaultChecked,
            'aria-disabled': disabled,
        };
    }
    const labelId = suffixId(id, 'label');
    return (React.createElement(React.Fragment, null,
        React.createElement(Box.Restricted
        // need to typecast here because TypeScript can't match `rest` with a union elementType
        , { 
            // need to typecast here because TypeScript can't match `rest` with a union elementType
            elementType: UNSAFE_elementType, ...labelProps, ...rest, id: labelId, className: clsx('mollie-ui-checkbox', className), ref: UNSAFE_labelRef, onFocus: UNSAFE_labelOnFocus, onBlur: UNSAFE_labelOnBlur, tabIndex: UNSAFE_omitInput ? 0 : undefined, role: UNSAFE_omitInput ? role || 'checkbox' : undefined, "data-checked": checked, "data-disabled": disabled },
            !UNSAFE_omitInput && (React.createElement(VisuallyHidden, { elementType: "input", role: role, value: value, name: name, checked: checked, disabled: disabled, required: required, onChange: callMultiple(onChange, (e) => {
                    setChecked(e.target.checked);
                    setCheckedValue(e.target.value);
                }), onFocus: onFocus, onBlur: onBlur, type: "checkbox", id: id, "aria-label": ariaLabel, "aria-labelledby": ariaLabel ? undefined : ariaLabelledBy, "aria-describedby": ariaDescribedBy || validationText
                    ? aggregate(ariaDescribedBy, validationText ? validationTextId(id) : undefined)
                    : undefined, ref: inputRef, tabIndex: UNSAFE_inputTabIndex, autoFocus: autoFocus, "data-autofocus": autoFocus, "data-table-row-tabbable": tableRowTabbable })),
            React.createElement("span", { className: clsx('mollie-ui-checkbox-indicator', UNSAFE_indicatorClassName) }, typeof UNSAFE_indicatorContent !== 'undefined' ? (UNSAFE_indicatorContent) : (React.createElement(Icon, { src: Check, size: "extra-small", className: "mollie-ui-checkbox-icon" }))),
            prefix && React.createElement("div", { className: "mollie-ui-checkbox-prefix" }, prefix),
            (label || flattenChildren(children).length > 0) && (React.createElement("div", { className: clsx('mollie-ui-checkbox-content', UNSAFE_contentClassName) },
                label,
                complement && (React.createElement(React.Fragment, null,
                    label && ' ',
                    React.createElement("span", { className: "mollie-ui-checkbox-complement" }, complement))),
                children,
                description && (React.createElement("div", { className: "mollie-ui-checkbox-description" }, description))))),
        validationText && (React.createElement("div", { className: "mollie-ui-checkbox-validation-text", id: validationTextId(id) },
            React.createElement(Icon, { src: AlertOutline }),
            " ",
            validationText))));
}
//# sourceMappingURL=Checkbox.js.map